module.exports = __webpack_public_path__ + "static/team_pic-1021b70d28bc2968794ab85f18633805.png";